export default __webpack_public_path__ + "static/media/ce-4.835a7953.png";